import React, { useEffect, useState } from "react";

import {
BrowserRouter as Router,
Routes,
Route,
} from "react-router-dom";

// ============================================================
// APPLICATIONS
// ============================================================

import AdministratorApp from "./applications/administrator/AdministratorApp";
import ProcurementApp from "./applications/procurement/ProcurementApp";

// ============================================================
// OTHER
// ============================================================

import LoginPage from "./components/LoginPage/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";

// ============================================================
// API / ROLES
// ============================================================

import { getCurrentUser } from "./components/api/auth";
import { getRoleFromGroups } from "./config/roles";

// ============================================================
// APP
// ============================================================

function App() {
// ==========================================================
// AUTH STATE
// ==========================================================

const [user, setUser] = useState(null);
const [checkingAuth, setCheckingAuth] = useState(true);

// ==========================================================
// ROLE
// ==========================================================

const role = user
? getRoleFromGroups(user.groups || [])
: null;

// ==========================================================
// LOAD CURRENT USER
// ==========================================================

useEffect(() => {
let isMounted = true;


async function loadUser() {
  try {
    const accessToken = localStorage.getItem("access_token");

    // ------------------------------------------------------
    // Нет токена
    // ------------------------------------------------------

    if (!accessToken) {
      if (isMounted) {
        setUser(null);
        setCheckingAuth(false);
      }

      return;
    }

    // ------------------------------------------------------
    // Получаем текущего пользователя
    // ------------------------------------------------------

    const currentUser = await getCurrentUser();

    // ------------------------------------------------------
    // Токен недействителен
    // ------------------------------------------------------

    if (!currentUser) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("username");

      if (isMounted) {
        setUser(null);
        setCheckingAuth(false);
      }

      return;
    }

    // ------------------------------------------------------
    // Нормализуем пользователя
    // ------------------------------------------------------

    const normalizedUser = {
      id: currentUser.id,
      name: currentUser.username,
      username: currentUser.username,
      groups: currentUser.groups || [],
      avatar: "https://i.pravatar.cc/150?img=3",
    };

    // ------------------------------------------------------
    // Определяем роль
    // ------------------------------------------------------

    const currentRole = getRoleFromGroups(
      normalizedUser.groups
    );

    console.log("================================");
    console.log("[AUTH] CURRENT USER:", normalizedUser);
    console.log("[AUTH] GROUPS:", normalizedUser.groups);
    console.log("[AUTH] ROLE:", currentRole);
    console.log(
      "[AUTH] DEFAULT PATH:",
      currentRole?.defaultPath
    );
    console.log("================================");

    // ------------------------------------------------------
    // Сохраняем пользователя
    // ------------------------------------------------------

    if (isMounted) {
      setUser(normalizedUser);
      setCheckingAuth(false);
    }
  } catch (error) {
    console.error(
      "[AUTH] Ошибка загрузки пользователя:",
      error
    );

    if (isMounted) {
      setUser(null);
      setCheckingAuth(false);
    }
  }
}

loadUser();

return () => {
  isMounted = false;
};


}, []);

// ==========================================================
// LOGIN USER HANDLER
// ==========================================================

const handleSetUser = (nextUser) => {
console.log("[AUTH] LOGIN USER:", nextUser);


setUser(nextUser);


};

// ==========================================================
// AUTH LOADING
// ==========================================================

if (checkingAuth) {
return ( <div className="h-screen w-screen flex items-center justify-center"> <div className="text-center"> <div className="text-xl font-medium">
Загрузка... </div>


      <div className="text-sm text-gray-500 mt-2">
        Проверяем авторизацию
      </div>
    </div>
  </div>
);


}

// ==========================================================
// ROUTER
// ==========================================================

return ( <Router> <Routes>
{/* ====================================================
LOGIN
==================================================== */}

    <Route
      path="/login"
      element={
        <LoginPage setUser={handleSetUser} />
      }
    />

    {/* ====================================================
        AUTHENTICATED APPLICATION
    ==================================================== */}

    <Route
      path="/*"
      element={
        <ProtectedRoute
          user={user}
          role={role}
        >
          <AuthenticatedApplication
            user={user}
            role={role}
          />
        </ProtectedRoute>
      }
    />
  </Routes>
</Router>


);
}

// ============================================================
// AUTHENTICATED APPLICATION
// ============================================================
//
// App.js больше не знает внутренние страницы приложений.
//
// Он только определяет:
//
// /procurement/*
//      -> ProcurementApp
//
// остальные маршруты
//      -> AdministratorApp
//
// В будущем:
//
// /accountant/*
//      -> AccountantApp
//
// ============================================================

function AuthenticatedApplication({
user,
role,
}) {
return ( <Routes>
{/* ======================================================
PROCUREMENT APPLICATION
====================================================== */}


  <Route
    path="/procurement/*"
    element={
      <ProcurementApp
        user={user}
        role={role}
      />
    }
  />

  {/* ======================================================
      ADMINISTRATOR APPLICATION
  ====================================================== */}

  <Route
    path="/*"
    element={
      <AdministratorApp
        user={user}
        role={role}
      />
    }
  />
</Routes>


);
}

export default App;
